module.exports = __webpack_public_path__ + "static/media/login-eye.ecdd32b7.svg";